import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_menu_hdr_RowClass} from '../../../dbschema';

export class MenuHeaderContainerModel extends BaseContainerModel {

  bl_cms_menu_hdr: bl_cms_menu_hdr_RowClass = new bl_cms_menu_hdr_RowClass();
}
